import axios from "axios";

// On the shop's own custom domain (viastyle.uk), the same deployment serves the
// API at /api on that domain. Calling it same-origin avoids cross-site CORS and
// third-party-cookie blocking (Safari/Chrome), which otherwise break login.
const SAME_ORIGIN_HOSTS = ["viastyle.uk"];
const onCustomDomain =
  typeof window !== "undefined" &&
  SAME_ORIGIN_HOSTS.some((h) => window.location.hostname === h || window.location.hostname.endsWith(`.${h}`));

export const API_BASE = onCustomDomain ? window.location.origin : process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  timeout: 60000,
});

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const gbp = (n) => {
  const v = Number(n) || 0;
  return `£${Number.isInteger(v) ? v.toFixed(0) : v.toFixed(2)}`;
};

export const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("/")) return `${API_BASE}${src}`;
  return src;
};

export default api;
